<ng-container *ngIf="!itemsOnly; else multiChargeItems">
    <app-loading-overlay *ngIf="doShowLoadingOverlay"></app-loading-overlay>

    <button [matMenuTriggerFor]="multiChargeActions"
            class="absolute-more-btn btn btn-outline-secondary no-wrap">
        Actions
        <span *ngIf="charges?.selected?.length > 0">&nbsp;({{ charges.selected.length }})</span>
        <i class="fa fa-chevron-down ml-2"></i>
    </button>

    <mat-menu #multiChargeActions="matMenu" [overlapTrigger]="false">
        <ng-template [ngTemplateOutlet]="multiChargeItems"></ng-template>
    </mat-menu>
</ng-container>

<ng-template #multiChargeItems>
    <button mat-menu-item (click)="exportCsv.emit()">
        <span>Download CSV</span>
    </button>

    <div matTooltipPosition="left" [matTooltipDisabled]="liveCharges.length > 0" [matTooltip]="'Select at least one live charge to edit.'">
        <button mat-menu-item (click)="editCharges()" *ngIf="hasChargeWriteAccess" [disabled]="liveCharges.length === 0">
            Edit
        </button>
    </div>

    <div matTooltipPosition="left" [matTooltipDisabled]="activeIds.length > 0" [matTooltip]="'Select at least one active charge to forgive.'">
        <button mat-menu-item (click)="forgiveCharges()" *ngIf="hasChargeWriteAccess" [disabled]="activeIds.length === 0">
            <span>Forgive Remainder</span>
        </button>
    </div>

    <div matTooltipPosition="left" [matTooltipDisabled]="liveCharges.length > 0" [matTooltip]="'Select at least one live charge to delete.'">
        <button mat-menu-item (click)="deleteCharges()" *ngIf="hasChargeWriteAccess" [disabled]="liveCharges.length === 0">
            <span>Delete</span>
        </button>
    </div>

    <div matTooltipPosition="left" [matTooltipDisabled]="lateFeeIds.length > 0" [matTooltip]="'Select at least one charge with late fees to remove fee schedule.'">
        <button mat-menu-item (click)="removeLateFees()" *ngIf="hasChargeWriteAccess" [disabled]="lateFeeIds.length === 0"
                class="dropdown-item">
            <span>Remove Late Fees</span>
        </button>
    </div>

    <div matTooltipPosition="left" [matTooltipDisabled]="earlyDiscountIds.length > 0" [matTooltip]="'Select at least one charge with discounts to remove discount schedule.'">
        <button mat-menu-item (click)="removeEarlyDiscounts()" *ngIf="hasChargeWriteAccess" [disabled]="earlyDiscountIds.length === 0"
                class="dropdown-item">
            <span>Remove Early Discounts</span>
        </button>
    </div>

    <div matTooltipPosition="left" [matTooltipDisabled]="activeIds.length > 0" [matTooltip]="'Select at least one live charge to record payments against.'">
        <button mat-menu-item (click)="recordPayments()" *ngIf="hasPaymentWriteAccess" [disabled]="activeIds.length === 0"
                class="dropdown-item">
            <span>Record Payment</span>
        </button>
    </div>

    <div matTooltipPosition="left" [matTooltipDisabled]="activeIds.length > 0" [matTooltip]="'Select at least one live charge to record payments against. Multiple selections must have the same payor.'">
        <button mat-menu-item (click)="createPaymentPlans()" *ngIf="hasPaymentWriteAccess" [disabled]="activeIds.length === 0 || payorIds.size > 1"
                class="dropdown-item">
            <span>Payment Plan</span>
        </button>
    </div>

    <div matTooltipPosition="left" [matTooltipDisabled]="activeCharges.length > 0" [matTooltip]="'Select at least one active charge to send emails.'">
        <button mat-menu-item (click)="emailInvoices()" [disabled]="activeCharges.length === 0"
                *ngIf="hasChargeWriteAccess" class="dropdown-item">
            <span>Email Invoice(s)</span>
        </button>
    </div>

    <div matTooltipPosition="left" [matTooltipDisabled]="activeCharges.length > 0" [matTooltip]="'Select at least one active charge to send mail.'">
        <button mat-menu-item (click)="mailInvoices()" [disabled]="activeCharges.length === 0"
                type="button"
                *ngIf="hasChargeWriteAccess" class="dropdown-item">
            <span>Mail Invoice(s)</span>
        </button>
    </div>

    <div matTooltipPosition="left" [matTooltipDisabled]="deletedIds.length > 0" [matTooltip]="'Select at least one deleted charge to reinstate.'">
        <button mat-menu-item (click)="reinstateCharges()" *ngIf="hasChargeWriteAccess" [disabled]="deletedIds.length === 0"
                class="dropdown-item">
            <span>Reinstate Charges</span>
        </button>
    </div>

    <div matTooltipPosition="left" [matTooltipDisabled]="deletedIds.length > 0" [matTooltip]="'Select at least one deleted charge to archive.'">
        <button mat-menu-item (click)="archiveCharges()" *ngIf="(jwt.admin || jwt.superUser)" [disabled]="!deletedIds.length">
            <span>Archive Charges</span>
        </button>
    </div>
</ng-template>
